"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DateTimePickerInput = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DatePickerInput = _interopRequireDefault(require("./DatePickerInput"));

var _moment = _interopRequireDefault(require("moment"));

require("moment-timezone");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Holder = _styledComponents["default"].div.attrs(function () {
  return {
    name: "best-date-time-picker"
  };
}).withConfig({
  displayName: "DateTimePickerInput__Holder",
  componentId: "sc-1fx65ne-0"
})(["&&&{.input-group{position:static;ul{padding:0;li{font-size:0.625rem;}}}}"]);

var DateTimePickerInput = function DateTimePickerInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      className = _ref.className,
      disabled = _ref.disabled,
      timeZone = _ref.timeZone,
      rest = _objectWithoutProperties(_ref, ["value", "onChange", "className", "disabled", "timeZone"]);

  return _react["default"].createElement(Holder, null, _react["default"].createElement(_DatePickerInput["default"], _extends({
    timeZone: timeZone,
    value: value,
    onChange: onChange,
    disabled: disabled,
    className: className,
    showTimeSelect: true
  }, rest)));
};

exports.DateTimePickerInput = DateTimePickerInput;
DateTimePickerInput.propTypes = {
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  value: _propTypes["default"].any.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  timeZone: _propTypes["default"].string
};
DateTimePickerInput.defaultProps = {
  className: "",
  disabled: false,
  timeZone: _moment["default"].tz !== undefined ? _moment["default"].tz.guess() : "America/New_York"
};
var _default = DateTimePickerInput;
exports["default"] = _default;